export const checkBoxStyles = {
  checkBox: {
    colorScheme: 'green',
  },
};
